<template>
  <Swiper
    class="swiper"
    :modules="modules"
    :space-between="10"
    :autoplay="{ delay: 10000, disableOnInteraction: false }"
    :pagination="{ clickable: true, el: '.swiper-pagination' }"
    @swiper="onSwiper"
  >
    <!-- Accor banner -->
    <!-- https://dragonpass.atlassian.net/browse/VG-8316 下架 AccorBanner -->
    <!-- <SwiperSlide class="swiper-slide opentable" v-if="isLogin && (isVIAgent || isVIPAgent)">
      <div class="banner-content">
        <p class="banner-title">{{ $t('accor-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('accor-banner-desc') }}</p>
        <p class="banner-btn-text banner-btn-text-flex" @click="goToAccor">
          <span>{{ $t('accor-banner-btn') }}</span>
          <img src="~img/icon-arrow-out.svg" alt="icon arrow out" />
        </p>
      </div>
      <img
        style="height: 100%"
        src="~img/banner/accor-banner.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide> -->
    <!-- openTable banner -->
    <SwiperSlide class="swiper-slide opentable" v-if="isLogin && isVIPAgent">
      <div class="banner-content">
        <p class="banner-title">{{ $t('opentable-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('opentable-banner-desc') }}</p>
        <p class="banner-btn-text" @click="goToOpenTable">{{ $t('opentable-banner-btn') }}</p>
      </div>
      <img
        style="height: 100%"
        src="~img/banner/open-table-banner.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- prebooking banner -->
    <SwiperSlide class="swiper-slide prebooking" v-if="false">
      <img
        class="img-item prebooking"
        src="~img/banner/prebooking-banner.png"
        alt="Banner"
        v-if="clientWidth > 600"
      />
      <img
        class="img-item img-item-mobile prebooking"
        src="~img/banner/prebooking-banner-mobile.png"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p class="singup-desc title">
          {{ $t('prebook-headbanner-title1') }}<br />{{ $t('prebook-headbanner-title2') }}
        </p>
        <p class="singup-desc subtitle">{{ $t('prebook-banner-subtitle') }}</p>
        <p class="singup-desc btn-text" @click="goToPrebooking">
          {{ $t('prebook-headbanner-btn') }}
        </p>
      </div>
    </SwiperSlide>
    <!-- gigsky banner -->
    <SwiperSlide class="swiper-slide gigsky" v-if="isLogin && isVIPAgent">
      <!-- PC -->
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/banner/gigsky-banner.svg"
        alt="Banner"
        v-if="clientWidth > 500"
      />
      <!-- Mobile -->
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/banner/gigsky-banner-mobile.svg"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p class="singup-desc title">{{ $t('gigsky-banner-title') }}</p>
        <p class="singup-desc subtitle">{{ $t('gigsky-banner-desc') }}</p>
        <p class="singup-desc btn-text" @click="goToGigsky">{{ $t('gigsky-banner-btn') }} ></p>
      </div>
    </SwiperSlide>
    <!-- 未登录状态下展示的banner -->
    <SwiperSlide class="swiper-slide" v-if="!isLogin">
      <img class="img-item" src="~img/home_banner_1.png" alt="Banner" />
      <div class="signup-btn context-banner">
        <p class="singup-desc">
          {{ $t('limitless') }}
        </p>
        <button class="btn" @click="handleSignUp">{{ $t('signup') }}</button>
      </div>
    </SwiperSlide>
    <!--  R&C Benefits -->
    <SwiperSlide class="swiper-slide" v-if="isLogin && isVIPAgent">
      <!-- PC -->
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/banner/R&C_Benefits_pc.png"
        alt="Banner"
        v-if="clientWidth > 500"
      />
      <!-- Mobile -->
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/banner/R&C_Benefits_mobile.png"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p class="singup-desc" v-html="$t('home-head-banner-desc-R&C-benefits')"></p>
        <button class="btn" @click="bookNow">{{ $t('btn-book-now') }}</button>
      </div>
    </SwiperSlide>
    <!-- 应用app store下载banner -->
    <SwiperSlide class="swiper-slide">
      <!-- PC -->
      <template v-if="clientWidth > 1024">
        <img
          class="img-item"
          src="~img/home_banner_2_fr.png"
          alt="Banner"
          v-if="$i18n.locale === 'fr_CA'"
        />
        <img class="img-item" src="~img/home_banner_2_en.png" alt="Banner" v-else />
      </template>
      <!-- Mobile -->
      <template v-if="clientWidth <= 1024">
        <img
          class="img-item img-item-mobile"
          v-if="$i18n.locale === 'fr_CA'"
          src="~img/mobilemobile-fr.png"
          alt="Banner"
        />
        <img class="img-item img-item-mobile" src="~img/mobilemobile-en.png" alt="Banner" v-else />
      </template>
      <div class="store-btn" role="banner store">
        <p class="store-desc1">
          {{ $t('limitless2') }}
        </p>
        <p class="store-desc2">
          {{ $t('download-visa-airport') }}
        </p>
        <div class="store-app">
          <!-- en_US 和 fr_CA 图片不一样通过class动态绑定，背景图实现 -->
          <button
            :class="$i18n.locale === 'fr_CA' ? 'appstore2' : 'appstore'"
            role="button"
            @click="clickApple"
          ></button>
          <button
            :class="$i18n.locale === 'fr_CA' ? 'googleplay2' : 'googleplay'"
            role="button"
            @click="clickAndroid"
          ></button>
        </div>
      </div>
    </SwiperSlide>
    <!-- Crave Total benefits -->
    <!-- 下架Crave Total benefits https://dragonpass.atlassian.net/browse/VAC-1260 -->
    <!-- <SwiperSlide class="swiper-slide" v-if="isLogin && (isVIAgent || isVIPAgent)">
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/home_banner_CraveTotalBenefits_pc.png"
        alt="Banner"
        v-if="clientWidth > 500"
      />
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/home_banner_CraveTotalBenefits_mobile.png"
        alt="Banner"
        v-else
      />
      <div class="crave-total-benefits-box">
        <p
          class="crave-total-benefits-desc"
          v-html="$t('home-head-banner-desc-CraveTotalBenefits-VI_VIB')"
          v-if="isVIAgent"
        ></p>
        <p
          class="crave-total-benefits-desc"
          v-html="$t('home-head-banner-desc-CraveTotalBenefits-VIP')"
          v-else-if="isVIPAgent"
        ></p>
        <button class="btn" @click="redeemNow">{{ $t('btn-redeem-now') }}</button>
      </div>
    </SwiperSlide> -->
    <!-- RSVPBanner -->
    <!-- <SwiperSlide class="swiper-slide" v-if="!isLogin || isVIAgent || isVIBAgent || isVIPAgent">
      <img class="img-item img-banner-visa-promotion" src="~img/home_banner_0.png" alt="Banner" />
      <div class="signup-btn context-banner">
        <p
          class="singup-desc"
          v-html="$t('home-head-banner-desc-VI_VIB')"
          v-if="isVIAgent || isVIBAgent"
        ></p>
        <p class="singup-desc" v-html="$t('home-head-banner-desc-VIP')" v-else-if="isVIPAgent"></p>
        <p class="singup-desc" v-html="$t('home-head-banner-desc')" v-else></p>
        <button class="btn" @click="enrollNow">{{ $t('btn-enroll-now') }}</button>
      </div>
    </SwiperSlide> -->
    <!-- Visa Destinations Banner  -->
    <SwiperSlide
      class="swiper-slide opentable"
      v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)"
    >
      <div class="banner-content">
        <p class="banner-title">{{ $t('visa-destinations-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('visa-destinations-banner-desc') }}</p>
        <p class="banner-btn-text no-underline" @click="goToVisaDestinations">
          {{ $t('opentable-banner-btn') }}
        </p>
      </div>
      <img
        style="height: 100%"
        src="~img/banner/destinations-banner.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- Park'N Fly Benefits  -->
    <SwiperSlide
      class="swiper-slide opentable"
      v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)"
    >
      <div class="banner-content">
        <p class="banner-title">{{ $t('parknfly-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('parknfly-banner-desc') }}</p>
        <p class="banner-btn-text" @click="reserveNowTroonRewards">
          {{ $t('parknfly-banner-btn') }} >
        </p>
      </div>
      <img
        style="height: 100%"
        src="~img/banner/Park-N-Fly-Benefits.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- TroonRewardsBanner -->
    <!-- 下架Troon Rewards Banner https://dragonpass.atlassian.net/browse/VG-9203 -->
    <!-- <SwiperSlide class="swiper-slide" v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)">
      <img
        class="img-item img-banner-visa-promotion"
        v-if="$i18n.locale === 'fr_CA'"
        src="~img/troon_rewards_fr.png"
        alt="Banner"
      />
      <img
        class="img-item img-banner-visa-promotion"
        src="~img/troon_rewards_eng.png"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p
          class="singup-desc"
          v-html="$t('home-head-banner-desc-VI_VIB2')"
          v-if="isVIAgent || isVIBAgent"
        ></p>
        <p class="singup-desc" v-html="$t('home-head-banner-desc-VIP2')" v-else-if="isVIPAgent"></p>
        <button class="btn" @click="enrollNowTroonRewards">{{ $t('btn-enroll-now') }}</button>
      </div>
    </SwiperSlide> -->
    <!-- LuxuryHotelBanner -->
    <SwiperSlide class="swiper-slide" v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)">
      <img
        class="img-item img-banner-visa-promotion"
        v-if="$i18n.locale === 'fr_CA'"
        src="~img/luxury_hotel_fr.png"
        alt="Banner"
      />
      <img
        class="img-item img-banner-visa-promotion"
        src="~img/luxury_hotel_eng.png"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p class="singup-desc" v-html="$t('home-head-banner-desc-luxury-hotel')"></p>
        <button class="btn" @click="letgo">{{ $t('btn-let-go') }}</button>
      </div>
    </SwiperSlide>
    <div class="swiper-pagination" v-show="swiperSidesLength > 1"></div>
  </Swiper>
</template>

<script>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Autoplay, Pagination } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import { mapState } from 'vuex';
  // import '@/assets/css/swiper.css';
  // VI卡种不同环境大客户id集合
  const VI_AGENTIDS = {
    local: ['18430', '18432', '18435', '18665', '18664'],
    test: [],
    uat: ['18430', '18432', '18435', '18665', '18664', '21420'],
    pre: ['19909', '19917', '19922', '20041', '20042', '37220'],
    production: ['19909', '19917', '19922', '20041', '20042', '37220'],
  };
  // VIB卡种不同环境大客户id集合
  const VIB_AGENTIDS = {
    local: ['18446', '18441', '18442'],
    test: [],
    uat: ['18446', '18441', '18442'],
    pre: ['19913', '19918', '19923'],
    production: ['19913', '19918', '19923'],
  };
  // VIP卡种不同环境大客户id集合
  const VIP_AGENTIDS = {
    local: ['18436', '18428', '18429', '18437', '18444', '18445', '18433', '18434', '18431'],
    test: [],
    uat: ['18436', '18428', '18429', '18437', '18444', '18445', '18433', '18434', '18431'],
    pre: [
      '19902',
      '19903',
      '19906',
      '19907',
      '19911',
      '19914',
      '19915',
      '19920',
      '19924',
      '40463',
      '41983',
    ],
    production: [
      '19902',
      '19903',
      '19906',
      '19907',
      '19911',
      '19914',
      '19915',
      '19920',
      '19924',
      '40463',
      '41983',
    ],
  };

  export default {
    data() {
      return {
        clientWidth: document.documentElement.clientWidth,
        swiperSidesLength: 0,
        modules: [Autoplay, Pagination],
      };
    },

    mounted() {
      /* window.onresize = () => {
        this.clientWidth = document.documentElement.clientWidth;
      }; */
      window.addEventListener('resize', () => {
        this.clientWidth = document.documentElement.clientWidth;
      });
      // this.$nextTick(() => {
      //   this.swiperSidesLength = this.$refs.headSwiper.swiper.slides.length || 0;
      // });
    },

    unmounted() {
      window.onresize = null;
    },

    methods: {
      onSwiper(swiper) {
        this.swiperSidesLength = swiper.slides.length;
      },
      // redeemNow() {
      //   if (this.$i18n.locale === 'en_US' && this.visaCardType === 'VI-VIB') {
      //     window.open(
      //       'https://www.visainfinite.ca/infinite/en/index.html?category=allLink&offerId=alm1115',
      //     );
      //   }
      //   if (this.$i18n.locale === 'fr_CA' && this.visaCardType === 'VI-VIB') {
      //     window.open(
      //       'https://www.visainfinite.ca/infinite/fr/indice.html?category=allLink&offerId=alm1115',
      //     );
      //   }
      //   if (this.$i18n.locale === 'en_US' && this.visaCardType === 'VIP') {
      //     window.open(
      //       'https://www.visainfinite.ca/privilege/en/index.html?category=allLink&offerId=alm1116',
      //     );
      //   }
      //   if (this.$i18n.locale === 'fr_CA' && this.visaCardType === 'VIP') {
      //     window.open(
      //       'https://www.visainfinite.ca/privilege/fr/indice.html?category=allLink&offerId=alm1116',
      //     );
      //   }
      // },
      enrollNow() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open('https://www.rsvprewards.com/fr/visacanada');
        } else {
          window.open('https://www.rsvprewards.com/visacanada');
        }
      },
      letgo() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open('https://www.hotelsdeluxevisainfinite.ca/special-offers');
        } else {
          window.open('https://www.visainfiniteluxuryhotels.ca/special-offers');
        }
      },
      enrollNowTroonRewards() {
        if (this.visaCardType === 'VI-VIB') {
          window.open('https://offer.troongolfrewards.com/visainfinite');
        } else {
          window.open('https://offer.troongolfrewards.com/visainfiniteprivilege');
        }
      },
      reserveNowTroonRewards() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open(
            'https://www.parknfly.ca/fr/emplacement/stationnement-a-laeroport-toronto/?coupon=1132060',
          );
        } else {
          window.open('https://www.parknfly.ca/location/toronto-airport-parking/?coupon=1132060');
        }
      },
      clickApple() {
        window.open('https://apps.apple.com/gb/app/visa-airport-companion/id1291608009');
      },

      clickAndroid() {
        window.open('https://play.google.com/store/apps/details?id=com.dragonpass.en.latam');
      },

      handleSignUp() {
        this.$router.push('/sign-up');
      },
      bookNow() {
        window.open('http://www.relaischateaux.com/us/osp/visa');
      },
      goToPrebooking() {
        this.$router.push('/prebookbanner');
        // window.open('/prebookbanner', '_blank');
      },
      goToGigsky() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open('https://www.gigsky.com/fr/visa/gigsky-visa-canada');
        } else {
          window.open(' https://www.gigsky.com/visa/gigsky-visa-canada');
        }
      },
      goToOpenTable() {
        window.open('https://www.opentable.ca/c/en/visadining/');
      },
      // goToAccor() {
      //   if (this.isVIAgent) {
      //     window.open(
      //       'https://all.accor.com/a/en/offers/americas/visa-accor-premium-and-luxury-hotel-offer.html',
      //     );
      //   } else if (this.isVIPAgent) {
      //     window.open(
      //       'https://all.accor.com/a/en/offers/americas/visa-accor-premium-and-luxury-hotel-offer1.html',
      //     );
      //   }
      // },
      goToVisaDestinations() {
        window.open('https://destinations.visa.com/destinations/#/discover');
      },
    },

    computed: {
      ...mapState(['isLogin', 'visaCardType', 'userInfo']),
      isVIAgent() {
        const agentIds = [...VI_AGENTIDS[process.env.VUE_APP_CUSTOM_ENV]];
        return agentIds.includes(this.userInfo?.agentId);
      },
      isVIBAgent() {
        const agentIds = [...VIB_AGENTIDS[process.env.VUE_APP_CUSTOM_ENV]];
        return agentIds.includes(this.userInfo?.agentId);
      },
      isVIPAgent() {
        const agentIds = [...VIP_AGENTIDS[process.env.VUE_APP_CUSTOM_ENV]];
        return agentIds.includes(this.userInfo?.agentId);
      },
    },

    components: {
      Swiper,
      SwiperSlide,
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
</style>
